import _ from 'lodash';
import globalStore from '$$globalStore';
import constants from '$$helpers/constants';
import customDayTemplatesModel from '$$customDayTemplatesModel';
import projectsModel from '$$projectModel';

export default {
  prepareProjectConfigs() {
    const projectConfigs = [];

    const ganttIds = globalStore.getters['tasksModel/getAllData'].map(o => o.id);

    ganttIds.forEach(ganttId => {
      // const calendar = this.ganttInstance.getCalendar(ganttId);
      let projectConfig = projectsModel.getProjectConfig(ganttId);
      const customDaysData = customDayTemplatesModel.serialize().find(data => +data.ganttId === +ganttId);

      // if (!calendar) {
      //   return;
      // }

      if (!projectsModel.getItem(ganttId)) {
        projectConfig = globalStore.getters['tasksModel/getItem'](ganttId).workloadData;
      }

      const daysHours = [];

      for (let i = 0; i < 7; i++) {
        if (projectConfig.durationData.showDay.includes(i)) {
          daysHours.push(projectConfig.durationData.showTime);
        } else {
          daysHours.push(false);
        }
      }

      projectConfigs.push({
        calendar: {
          id: ganttId,
          worktime: {
            hours: projectConfig.durationData.showTime,
            days: daysHours,
          },
        },
        ganttId,
        ganttConfig: {
          estimation_mode: projectConfig.estimation_mode,
          apply_resource_calendar: projectConfig.apply_resource_calendar,
          duration_unit: projectConfig.duration_unit || 'minute',
        },
        customDays: customDaysData ? customDaysData.customDays : [],
        totalEstimate: globalStore.getters['tasksModel/getTotalEstimateDataForProject'](ganttId),
      });
    });

    return projectConfigs;
  },

  prepareData(ganttIds) {
    const allProjectsResources = globalStore.getters['resourcesModel/getResourcesByProjectIdsAndType'](ganttIds, constants.RESOURCE_TIME_TYPE);
    const allProjectsData = globalStore.getters['tasksModel/getAllData'];

    return {
      allProjectsResources,
      allProjectsData,
      constants: {
        RESOURCE_TIME_TYPE: constants.RESOURCE_TIME_TYPE,
        TASK_TYPES: constants.TASK_TYPES,
      },
    };
  },
};
